import React from 'react';
import { HiOutlineCube } from 'react-icons/hi';

import '@google/model-viewer';

import { useTranslation } from 'react-i18next';

const Food = ({glb, portada}) => {
    const { t } = useTranslation(); 

    return (
        <div  style={{height:'300px', width:'300px'}} className="ml-auto mr-auto">
            <div className='flex justify-center'>
                <div>
                    <model-viewer
                        style={{height:'300px', width:'350px'}}
                        className='z-50'
                        src={glb} 
                        ar
                        ar-modes="webxr scene-viewer quick-look" 
                        camera-controls 
                        camera-orbit="0deg 0deg 1m" 
                        environment-image="neutral"
                        poster={portada}
                        loading="lazy"
                        progress
                        >
                        <div className="progress-bar hide" slot="progress-bar">
                            <div className="update-bar"></div>
                        </div>
                        <button 
                            className='rounded-2xl flex gap-2 justify-center items-center text-lg font-bold uppercase text-secondary w-full bg-black bg-opacity-80 border-4 border-secondary hover:bg-third hover:duration-150 p-2'
                            slot="ar-button" 
                            id="ar-button">
                            <HiOutlineCube className='text-lg'/>{t('boton3d')}
                        </button>
                        </model-viewer>
                </div>
            </div>
        </div>  
    )
}

export default Food